export default "__VITE_ASSET__DQX7Gd7y__"